export default "__VITE_ASSET__BEc_ZnNG__"